import type { ContentNugget } from '@backrs_ui/common-ui';

import { toAgentContextNugget } from '@backrs_ui/grow-ui/src/agentContext/toAgentContextNugget';
import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (sectionTitle: string, nuggets: readonly ContentNugget[]) => {
  useRegisterAgentContext({
    kind: 'nuggetList',
    description: `${sectionTitle} for this career path`,
    nuggets: nuggets.map(toAgentContextNugget),
  });
};
